<script lang="ts" setup>
import { version } from '../package.json';
import localforage from 'localforage';

// Stores
const global = globalStore();
const firebase = firebaseStore();
const { $firebase } = useNuxtApp();

// Init App Function
const init = async () => {
  const { $config } = useNuxtApp();
  const storedVersion = localStorage.getItem('nrjx_app_version');

  // Check version
  if (storedVersion !== version) {
    localforage.clear();
    localStorage.setItem('nrjx_app_version', version);
  }

  if ($config.public.maintenance) {
    global.setLoading(false);
    return;
  }
  await $firebase.authStateReady();
  await firebase.initAuth();

  global.initApp();
};
init();
</script>
<template>
  <u-app :tooltip="{ delayDuration: 200 }">
    <nuxt-layout v-if="!global.loading">
      <nuxt-page />
    </nuxt-layout>
    <div v-else class="flex items-center justify-center flex-col h-screen w-screen">
      <img src="./assets/nrjx-logo.svg" class="h-16 mb-8" />
      <ui-loader />
    </div>

    <!-- Modal and toast -->
    <ui-toast />
    <ui-alert />
  </u-app>
</template>
